<template>
    <div>
        <div class="card" v-if="item.children && item.children.length > 0">
            <div class="head">
                <div>
                    <a-checkbox :checked="values.findIndex(k => k == item.id) > -1" @change="changeNode"
                        :value="item.id">
                        <span style="color: black;font-weight: bold;font-size: 16px;"> {{ item.title }}</span>
                    </a-checkbox>
                </div>
                <div>
                    <a-button type="link">全选</a-button>
                    <a-button type="link">取消全选</a-button>
                </div>
            </div>
            <div v-for="v in item.children">
                <menu-digui :item="v" :values="values" @changepower="changeNode"></menu-digui>
            </div>
        </div>
        <div v-else class="content">
            <a-checkbox :checked="values.findIndex(k => k == item.id) > -1" @change="changeNode" :value="item.id">
                {{ item.title }}
            </a-checkbox>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            default() {
                return {}
            }
        },
        values: {
            type: Array,
            default() {
                return []
            }
        }
    },
    methods: {
        changeNode(e) {
            this.$emit('changepower', {
                checked: e.target.checked,
                value: [e.target.value]
            })
        },
    }
}
</script>
<style scoped>
.card {
    padding: 5px 20px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    margin-bottom: 10px;
}

.head {
    display: flex;
    justify-content: space-between;
}

.content {
    display: flex;

}

.digui {
    padding: 20px;
    box-sizing: border-box;
}
</style>